!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.th = t());
}(this, function () {
  "use strict";

  return [{
    locale: "th",
    pluralRuleFunction: function (e, t) {
      return "other";
    },
    fields: {
      year: {
        displayName: "ปี",
        relative: {
          0: "ปีนี้",
          1: "ปีหน้า",
          "-1": "ปีที่แล้ว"
        },
        relativeTime: {
          future: {
            other: "ในอีก {0} ปี"
          },
          past: {
            other: "{0} ปีที่แล้ว"
          }
        }
      },
      "year-short": {
        displayName: "ปี",
        relative: {
          0: "ปีนี้",
          1: "ปีหน้า",
          "-1": "ปีที่แล้ว"
        },
        relativeTime: {
          future: {
            other: "ใน {0} ปี"
          },
          past: {
            other: "{0} ปีที่แล้ว"
          }
        }
      },
      month: {
        displayName: "เดือน",
        relative: {
          0: "เดือนนี้",
          1: "เดือนหน้า",
          "-1": "เดือนที่แล้ว"
        },
        relativeTime: {
          future: {
            other: "ในอีก {0} เดือน"
          },
          past: {
            other: "{0} เดือนที่ผ่านมา"
          }
        }
      },
      "month-short": {
        displayName: "เดือน",
        relative: {
          0: "เดือนนี้",
          1: "เดือนหน้า",
          "-1": "เดือนที่แล้ว"
        },
        relativeTime: {
          future: {
            other: "ใน {0} เดือน"
          },
          past: {
            other: "{0} เดือนที่แล้ว"
          }
        }
      },
      day: {
        displayName: "วัน",
        relative: {
          0: "วันนี้",
          1: "พรุ่งนี้",
          2: "มะรืนนี้",
          "-2": "เมื่อวานซืน",
          "-1": "เมื่อวาน"
        },
        relativeTime: {
          future: {
            other: "ในอีก {0} วัน"
          },
          past: {
            other: "{0} วันที่ผ่านมา"
          }
        }
      },
      "day-short": {
        displayName: "วัน",
        relative: {
          0: "วันนี้",
          1: "พรุ่งนี้",
          2: "มะรืนนี้",
          "-2": "เมื่อวานซืน",
          "-1": "เมื่อวาน"
        },
        relativeTime: {
          future: {
            other: "ใน {0} วัน"
          },
          past: {
            other: "{0} วันที่แล้ว"
          }
        }
      },
      hour: {
        displayName: "ชั่วโมง",
        relative: {
          0: "ชั่วโมงนี้"
        },
        relativeTime: {
          future: {
            other: "ในอีก {0} ชั่วโมง"
          },
          past: {
            other: "{0} ชั่วโมงที่ผ่านมา"
          }
        }
      },
      "hour-short": {
        displayName: "ชม.",
        relative: {
          0: "ชั่วโมงนี้"
        },
        relativeTime: {
          future: {
            other: "ใน {0} ชม."
          },
          past: {
            other: "{0} ชม. ที่แล้ว"
          }
        }
      },
      minute: {
        displayName: "นาที",
        relative: {
          0: "นาทีนี้"
        },
        relativeTime: {
          future: {
            other: "ในอีก {0} นาที"
          },
          past: {
            other: "{0} นาทีที่ผ่านมา"
          }
        }
      },
      "minute-short": {
        displayName: "น.",
        relative: {
          0: "นาทีนี้"
        },
        relativeTime: {
          future: {
            other: "ใน {0} นาที"
          },
          past: {
            other: "{0} นาทีที่แล้ว"
          }
        }
      },
      second: {
        displayName: "วินาที",
        relative: {
          0: "ขณะนี้"
        },
        relativeTime: {
          future: {
            other: "ในอีก {0} วินาที"
          },
          past: {
            other: "{0} วินาทีที่ผ่านมา"
          }
        }
      },
      "second-short": {
        displayName: "วิ",
        relative: {
          0: "ขณะนี้"
        },
        relativeTime: {
          future: {
            other: "ใน {0} วินาที"
          },
          past: {
            other: "{0} วินาทีที่แล้ว"
          }
        }
      }
    }
  }];
});